<template>
  <div class="icon-btn-close">
    <IconClose class="icon-close"/>
  </div>
</template>

<script lang="ts" setup>
import IconClose from '~icons/ic/baseline-close';

withDefaults(defineProps<{
  size?: number;
  color?: string;
}>(), {
  size: 14,
  color: '#919191'
});
</script>

<style scoped>
.icon-btn-close {
  display: flex;
  height: 30px;
  width: 30px;
  border: 1px solid #DFE1E6;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #919191;

  &:hover {
    background-color: #ff6a6a;
    color: #fff;
    border-color: #ff6a6a;
  }
}

.icon-close {
  width: 18px;
}
</style>